<div class="contact-form-wrapper">

  <button class="close-btn" type="button" (click)="close()">×</button>

  <!-- SUCCESS VIEW -->
  <div *ngIf="submitSuccess" class="success-container">
    <div class="success-icon">
      <i class="ri-checkbox-circle-fill"></i>
    </div>

    <h2 class="form-title">Thank you!</h2>
    <p class="form-subtitle">
      We have received your request.
    </p>

    <p class="success-text">
      Our team will get back to you shortly.
    </p>

    <!-- <button class="submit-btn mt-3" (click)="close()">Close</button> -->
  </div>

  <!-- FORM VIEW -->
  <form *ngIf="!submitSuccess" [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>

    <h2 class="form-title">Contact Us</h2>
    <p class="form-subtitle">
      This form is for general enquiries. For job applications, please visit our <a href="/careers/kalpita-open-positions" class="bold-link">Careers Page</a>
    </p>

    <div class="form-group">
      <input type="text" formControlName="name" placeholder="Full Name" />
      <small *ngIf="f['name'].touched && f['name'].errors">

        <span *ngIf="f['name'].errors?.['required']">
          Name is required
        </span>

        <span *ngIf="f['name'].errors?.['pattern']">
          Name should contain only letters
        </span>

      </small>
    </div>

    <div class="form-group">
      <input type="text" formControlName="mobile" placeholder="Mobile Number" />
      <small *ngIf="f['mobile'].touched && f['mobile'].errors">

        <span *ngIf="f['mobile'].errors?.['required']">
          Mobile number is required
        </span>

        <span *ngIf="f['mobile'].errors?.['pattern']">
          Enter a valid 10-digit mobile number starting with 6-9
        </span>

      </small>
    </div>

    <div class="form-group">
      <input type="email" formControlName="email" placeholder="Working Email" />
      <small *ngIf="f['email'].touched && f['email'].errors">

        <span *ngIf="f['email'].errors?.['required']">
          Email is required
        </span>

        <span *ngIf="f['email'].errors?.['pattern']">
          Enter a valid email address
        </span>

      </small>
    </div>

    <div class="form-group">
      <input type="text" formControlName="company" placeholder="Company Name" />
      <small *ngIf="f['company'].touched && f['company'].errors">

        <span *ngIf="f['company'].errors?.['required']">
          Company name is required
        </span>

        <span *ngIf="f['company'].errors?.['pattern']">
          Company name can contain only letters
        </span>

      </small>
    </div>

    <div class="form-group">
      <textarea rows="3" formControlName="reason" placeholder="Reason for reaching out">
      </textarea>
      <small *ngIf="f['reason'].touched && f['reason'].errors">

        <span *ngIf="f['reason'].errors?.['required']">
          Reason is required
        </span>

        <span *ngIf="f['reason'].errors?.['pattern']">
          Reason can contain only letters 
        </span>

      </small>
    </div>

    <!-- ERROR MESSAGE -->
    <div class="error-box" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <button type="submit" class="submit-btn" [disabled]="isSubmitting">

      <span *ngIf="!isSubmitting">Submit</span>

      <span *ngIf="isSubmitting">
        <i class="ri-loader-4-line spinning"></i> Submitting...
      </span>

    </button>

  </form>

</div>